(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["snip-product-sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
    function visibleATC() {
      var list = Array.prototype.slice.call(document.querySelectorAll('.AddtoCart'));
      var vis = list.filter(function (el) { return el.offsetParent !== null; });
      return vis[0] || list[0] || null;
    }
    function init() {
      var bar = document.querySelector('[data-sv-sticky]');
      if (!bar) return;
      var atc = visibleATC();
      if (!atc) return;
      var proxy = bar.querySelector('[data-sv-sticky-add]');
      if (proxy) {
        proxy.addEventListener('click', function () {
          var target = visibleATC();
          if (target) { target.click(); }
        });
      }
      var anchorY = 0;
      function measure() {
        var r = atc.getBoundingClientRect();
        anchorY = r.top + (window.scrollY || window.pageYOffset || 0);
      }
      function onScroll() {
        var y = window.scrollY || window.pageYOffset || 0;
        var nearBottom = (window.innerHeight + y) >= (document.body.scrollHeight - 160);
        var past = anchorY > 0 && y > (anchorY - 40);
        if (past && !nearBottom) { bar.classList.add('is-visible'); bar.setAttribute('aria-hidden', 'false'); }
        else { bar.classList.remove('is-visible'); bar.setAttribute('aria-hidden', 'true'); }
      }
      measure(); onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
      window.setTimeout(function () { measure(); onScroll(); }, 1200);
    }
    if (document.readyState !== 'loading') { init(); }
    else { document.addEventListener('DOMContentLoaded', init); }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sv-notify-unavailable"] && !Shopify.designMode) return;
  try {
    (function () {
    /* CTA reveal + focus management only. The picker script (snip-product-variants)
       owns show/hide of the whole block, the reason text, and the hidden phone value. */
    function initNotify(root) {
      var cta = root.querySelector('[data-sv-notify-cta]');
      var wrap = root.querySelector('[data-sv-notify-formwrap]');
      if (!cta || !wrap) return;
      cta.addEventListener('click', function () {
        /* one-way reveal: show the compact form and COLLAPSE the CTA so there are never two
           stacked full-width black buttons (the CTA + Senda). */
        wrap.removeAttribute('hidden');
        cta.setAttribute('aria-expanded', 'true');
        cta.setAttribute('hidden', '');
        var field = wrap.querySelector('input[type="email"], input[type="submit"], button[type="submit"]');
        if (field) field.focus();
      });
    }
    function boot() {
      var nodes = document.querySelectorAll('[data-sv-notify]');
      for (var i = 0; i < nodes.length; i++) initNotify(nodes[i]);
    }
    if (document.readyState !== 'loading') { boot(); }
    else { document.addEventListener('DOMContentLoaded', boot); }
  })();
  } catch(e) { console.error(e); }
})();

})();
